import { useEffect } from 'react'

let locks = 0
let previousOverflow = ''
let previousPadding = ''

// Stops the page behind an open panel from scrolling. Nested panels share one lock.
export const useLockBodyScroll = (active: boolean): void => {
    useEffect(() => {
        if (!active) return

        const { body, documentElement } = document

        if (locks === 0) {
            const scrollbar = window.innerWidth - documentElement.clientWidth

            previousOverflow = body.style.overflow
            previousPadding = body.style.paddingRight
            body.style.overflow = 'hidden'

            if (scrollbar > 0) body.style.paddingRight = `${scrollbar}px`
        }

        locks += 1

        return () => {
            locks = Math.max(0, locks - 1)

            if (locks === 0) {
                body.style.overflow = previousOverflow
                body.style.paddingRight = previousPadding
            }
        }
    }, [active])
}
